import { DataGrid, GridActionsCellItem, GridRowModes } from "@mui/x-data-grid";
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { useEffect, useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import { Button } from 'antd';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';

export const DataGridVehicle = ({
    loadingData,
    data,
    columns,
    pageSize,
    onEditOpenModal,
    handleOpenModal,
    rowsPerPageOptions,
    checkboxSelection,
    updateRecord,
    deleteRecord,
    lockVehicle,
    updateProcessVehiclesIsTrue,
    listVehicleInUpdate,
}) => {
    const [rows, setRows] = useState(data);
    const [rowModesModel, setRowModesModel] = useState({});
    const [openDialog, setOpenDialog] = useState(false);
    const [openDialogConfirmLock, setOpenDialogConfirmLock] = useState(false);
    const [idToDelete, setIdToDelete] = useState('');
    const [idToLock, setIdToLock] = useState('');
    const [openDialogEditVehicle, setOpenDialogEditVehicle] = useState(false);
    const [selectEditVehicle, setSelectEditVehicle] = useState({});

    useEffect(() => {
        setRows(data);
    }, [data]);


    let columnsWithActions = [{
        field: 'actions',
        type: 'actions',
        headerName: '',
        cellClassName: 'actions',
        width: 80,
        editable: false,
        headerAlign: 'right',
        align: 'left',
        getActions: (params) => {
            const id = params.row.id;
            if (params.row.isRemoved) {
                return [];
            } else {
                return [
                    <GridActionsCellItem
                        title={"Editar"}
                        icon={<EditRoundedIcon />}
                        label="Editar"
                        className="textPrimary"
                        onClick={() => onEditOpenModal ? handleEditModalOpen(params.row) : handleEditClick(id)}
                        color="inherit"
                        sx={{ color: 'rgba(1, 49, 144, 0.69)', ':hover': { backgroundColor: 'rgb(202, 219, 254)' } }}
                    />,
                    <GridActionsCellItem
                        title={"Deletar"}
                        icon={<DeleteRoundedIcon />}
                        label="Deletar"
                        onClick={() => handleDeleteClick(id)}
                        color="inherit"
                        sx={{ color: 'red', ':hover': { backgroundColor: 'rgb(250, 219, 219)' } }}
                    />,
                ];
            }
        },
    }];

    var columnFinal = columnsWithActions.concat(columns);

    const handleEditModalOpen = item => {
        if (updateProcessVehiclesIsTrue && listVehicleInUpdate.includes(item.id)) {
            setSelectEditVehicle(item);
            setOpenDialogEditVehicle(true);

        } else {
            handleOpenModal(item);
        }

    }

    const handleEditClick = (id) => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };

    const handleSaveClick = (id) => () => {
        setRowModesModel({
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: false },
        });
    };

    const handleDeleteClick = (id) => {
        setIdToDelete(id);
        setOpenDialog(true);
    };

    const handleCancelClick = (id) => () => {
        setRowModesModel({
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });
    };

    const handleRowEditStop = (params, event) => {
        event.defaultMuiPrevented = true;
    };

    const handleRowEditStart = (params, event) => {
        event.defaultMuiPrevented = true;
    };

    const processRowUpdateError = (err) => { };

    const processRowUpdate = (newRow) => {
        updateRecord(newRow);
        setRowModesModel({
            ...rowModesModel,
            [newRow.id]: { mode: GridRowModes.View, ignoreModifications: true },
        });
    };

    const confirmDeleteRegister = () => {
        deleteRecord(idToDelete);
        setOpenDialog(false);
    }

    const notDeleteRegister = () => {
        setOpenDialog(false);
    }

    const confirmLockVehicle = () => {
        lockVehicle(idToLock);
        setOpenDialogConfirmLock(false);
    }

    const notLockVehicle = () => {
        setOpenDialogConfirmLock(false);
    }

    const handleOpenDialogEditVehicle = () => {
        handleOpenModal(selectEditVehicle);
        setOpenDialogEditVehicle(false);
    }

    const handleCloseDialogEditVehicle = item => {
        setOpenDialogEditVehicle(false);
    }

    const configComponentsProps = {
        panel: {
            sx: {
                '& .MuiTypography-root': {
                    color: '#2f3237',
                    fontSize: 12,
                },

                '& .MuiSvgIcon-root': {
                    color: '#2f3237',
                    marginTop: '-1px'
                },
                '& .batteryTrunk': {
                    marginTop: '-1px',
                    color: '#2f3237',
                },
                '& .svg-inline--fa': {
                    marginTop: '-1px',
                    color: '#2f3237',
                },
                '& .MuiDataGrid-columnsPanelRow:first-of-type': {
                    display: 'none'
                },
                "& .MuiDataGrid-panelFooter button:first-of-type": {
                    display: "none"
                },


            },
        },
        footer: {
            sx: {
                '& .MuiTablePagination-root': {
                    minHeight: '30px',
                    height: '30px',

                },
                '& .MuiTablePagination-toolbar': {
                    marginTop: '5px',
                    minHeight: '10px',
                    height: '10px',
                },
                '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                    fontSize: '12px',
                    margin: 0,
                    color: 'black !important',
                },
                '& .MuiTablePagination-select': {
                    margin: 0,
                    fontSize: '12px',

                },
                '& .MuiTablePagination-actions': {
                    margin: 0,
                },
                '& .css-rtrcn9-MuiTablePagination-root:last-child': {
                    display: 'contents',
                },
            },
        },
    }

    return (
        <>
            <Box sx={{ height: 1, width: 1 }}>
                <Box
                    sx={{
                        height: '60vh',
                        width: '100%',
                        '& .dataGrid-true': {
                            bgcolor: '#eeeeee'
                        },
                        '& .dataGrid-false': {
                            bgcolor: '#ffffff'
                        },
                    }}
                >
                    <DataGrid
                        components={{
                            NoRowsOverlay: () => (
                                <Stack height="100%" alignItems="center" justifyContent="center">
                                    Não há registros.
                                </Stack>
                            ),
                        }}
                        disableSelectionOnClick={true}
                        loading={loadingData}
                        rows={rows}
                        columns={columnFinal}
                        rowModesModel={rowModesModel}
                        onRowEditStart={handleRowEditStart}
                        onRowEditStop={handleRowEditStop}
                        processRowUpdate={processRowUpdate}
                        onProcessRowUpdateError={processRowUpdateError}
                        pageSize={pageSize ?? 10}
                        density={'compact'}
                        rowHeight={70}
                        headerHeight={70}
                        rowsPerPageOptions={rowsPerPageOptions ?? [5]}
                        checkboxSelection={checkboxSelection}
                        experimentalFeatures={{ newEditingApi: true }}
                        getRowClassName={(params) => `dataGrid-${params.row.isRemoved ? 'true' : 'false'}`}
                        componentsProps={configComponentsProps}

                    />
                </Box>
                <Dialog open={openDialogEditVehicle}>
                    <DialogTitle>ATENÇÃO!</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Um processo de atualização de limiares está em curso no momento.
                            Deseja, ainda assim, prosseguir e configurar novos limiares?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button type={"primary"} style={{ background: "#008000", color: "white" }} onClick={handleOpenDialogEditVehicle}>Sim</Button>
                        <Button type={"primary"} style={{ background: "#D21717", color: "white" }} onClick={handleCloseDialogEditVehicle}>Não</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={openDialog}>
                    <DialogTitle>Confirmação de Exclusão</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Você tem certeza que deseja excluir esse registro?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button type={"primary"} style={{ background: "#008000", color: "white" }} onClick={confirmDeleteRegister}>Sim</Button>
                        <Button type={"primary"} style={{ background: "#D21717", color: "white" }} onClick={notDeleteRegister}>Não</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={openDialogConfirmLock}>
                    <DialogTitle>Confirmação de Bloqueio</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Você tem certeza que deseja BLOQUEAR esse veículo?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button type={"primary"} style={{ background: "#008000", color: "white" }} onClick={confirmLockVehicle} >Sim</Button>
                        <Button type={"primary"} style={{ background: "#D21717", color: "white" }} onClick={notLockVehicle} >Não</Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </>
    );
}